import { Pipe, PipeTransform } from '@angular/core';
import { FormatHelper } from '../helpers/format.helper';

@Pipe({
  name: 'monetaire'
})
export class MonetairePipe implements PipeTransform {

  transform(value: any, avecDevise: boolean = true): any {
    return FormatHelper.toChaineMonetaire(value, avecDevise);
  }

}



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/shared/pipes/monetaire.pipe.ts